<template>
  <div class="tj-wrapper" v-if="db">
    <!--Style Switcher Section End-->
    <header class="tj-header">
      <!--Header Content Start-->
      <div class="container">
        <div class="row">
          <!--Toprow Content Start-->
          <div class="col-md-3 col-sm-4 col-xs-12 logo-container">
            <!--Logo Start-->
            <img :src="db.productInfo.logoURL" :alt="db.productInfo.name" srcset class="logo-c" />
            <!-- <div class="tj-logo">
              <h1>
                <a href="home-1.html">Prime Cab</a>
              </h1>
            </div>-->
            <!--Logo End-->
          </div>
          <div class="col-md-3 col-sm-4 col-xs-12">
            <div class="info_box">
              <i class="fa fa-home"></i>
              <div class="info_text">
                <span class="info_title">Address</span>
                <span><a :href="'https://www.google.com/maps/place/Ambassador+Cars+%26+Courier+Service/@51.5591841,-0.1205065,17z/data=!4m13!1m7!3m6!1s0x48761ba0fa238bd7:0x93e6d509dc8d069a!2s508+Holloway+Rd,+London+N7+6JD,+UK!3b1!8m2!3d51.5590849!4d-0.120972!3m4!1s0x48761ba0fb5e3b0d:0x7bf8fe9bf666acf3!8m2!3d51.559084!4d-0.120997'" :target="'_blank'">{{db.productInfo.address}}</a></span>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-4 col-xs-12">
            <div class="info_box">
              <i class="fa fa-envelope"></i>
              <div class="info_text">
                <span class="info_title">Email Us</span>
                <span>
                  <a :href="'mailto:'+db.productInfo.email">{{db.productInfo.email}}</a>
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-xs-12">
            <div class="phone_info">
              <div class="phone_icon">
                <i class="fas fa-phone-volume"></i>
              </div>
              <div class="phone_text">
                <span>
                  <a :href="'tel:'+db.productInfo.phone">{{db.productInfo.phone}}</a>
                </span>
              </div>
            </div>
          </div>
          <!--Toprow Content End-->
        </div>
      </div>

      <div class="tj-nav-row">
        <div class="container">
          <div class="row">
            <!--Nav Holder Start-->
            <div class="tj-nav-holder">
              <!--Menu Holder Start-->
              <nav class="navbar navbar-default">
                <div class="navbar-header">
                  <button
                    type="button"
                    class="navbar-toggle collapsed"
                    data-toggle="collapse"
                    data-target="#tj-navbar-collapse"
                    aria-expanded="false"
                  >
                    <span class="sr-only">Menu</span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                  </button>
                </div>
                <!-- Navigation Content Start -->
                <div class="collapse navbar-collapse" id="tj-navbar-collapse">
                  <ul class="nav navbar-nav">
                    <li>
                      <router-link to="/" aria-label="Home">Home</router-link>
                    </li>
                    <li>
                      <router-link to="/aboutus" aria-label="About Us">About Us</router-link>
                    </li>
                    <li>
                      <router-link to="/services" aria-label="Our Services">Our Services</router-link>
                    </li>
                    <li>
                      <router-link to="/fleets" aria-label="Our Fleets">Our Fleets</router-link>
                    </li>
                    <li>
                      <router-link to="/careers" aria-label="Careers">Careers</router-link>
                    </li>
                    <li>
                      <router-link to="/contactus" aria-label="Contactus">Contact us</router-link>
                    </li>
                  </ul>
                </div>
                <!-- Navigation Content Start -->
              </nav>
              <!--Menu Holder End-->
              <div class="book_btn" @click="movetoTop">
                <router-link to="/">
                  Book Now
                  <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                </router-link>
              </div>
            </div>
            <!--Nav Holder End-->
          </div>
        </div>
      </div>
    </header>
    <!--Header Content End-->

    <!-- Router View Start -->
    <router-view />
    <!-- router View End -->

    <!--Call To Action 2 Content Start-->
    <section class="tj-cal-to-action2">
      <div class="container">
        <div class="row">
          <div class="col-md-9 col-sm-9">
            <div class="cta-tagline">
              <h2>Great Places, Great Prices.</h2>
            </div>
          </div>

          <div class="col-md-3 col-sm-3">
            <div class="cta-btn" @click="movetoTop()">
              <router-link to="/">
                Book Now
                <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--Call To Action 2 Content End-->

    <!--Footer Content Start-->
    <section class="tj-footer">
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <div class="about-widget widget">
              <h3>About {{db.productInfo.name}}</h3>
              <p>At Ambassador cars, we are always trying our best to know our customersso we can cater to their needs. Most clients stick with us for our professionalism,reliability and kindness. We are so confident you’ll like our service, we offer reduced feeswhen you book through our mobile app. Call us now or download the app!</p>
              <ul class="fsocial-links">
                <li v-if="db.productInfo.facebook">
                  <a :href="db.productInfo.facebook">
                    <i class="fab fa-facebook-f"></i>
                  </a>
                </li>
                <li v-if="db.productInfo.twitter">
                  <a :href="db.productInfo.twitter">
                    <i class="fab fa-twitter"></i>
                  </a>
                </li>
                <li v-if="db.productInfo.linkedin">
                  <a :href="db.productInfo.linkedin">
                    <i class="fab fa-linkedin-in"></i>
                  </a>
                </li>
                <li v-if="db.productInfo.pinterest">
                  <a :href="db.productInfo.pinterest">
                    <i class="fab fa-pinterest"></i>
                  </a>
                </li>
                <li v-if="db.productInfo.instagram">
                  <a :href="db.productInfo.instagram">
                    <i class="fab fa-instagram"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-4"></div>
          <div class="col-md-4">
            <div class="contact-info widget">
              <h3>Contact Info</h3>
              <ul class="contact-box">
                <li>
                  <i class="fas fa-home" aria-hidden="true"></i>
                 <a :href="'https://www.google.com/maps/place/Ambassador+Cars+%26+Courier+Service/@51.5591841,-0.1205065,17z/data=!4m13!1m7!3m6!1s0x48761ba0fa238bd7:0x93e6d509dc8d069a!2s508+Holloway+Rd,+London+N7+6JD,+UK!3b1!8m2!3d51.5590849!4d-0.120972!3m4!1s0x48761ba0fb5e3b0d:0x7bf8fe9bf666acf3!8m2!3d51.559084!4d-0.120997'" :target="'_blank'">508 Holloway Rd,<br/> London, N7 6JD </a>
                </li>
                <li>
                  <i class="far fa-envelope-open"></i>
                  <a :href="'mailto:'+db.productInfo.email">{{db.productInfo.email}}</a>
                </li>
                <li>
                  <i class="fas fa-phone-square"></i>
                 <a :href="`tel:${db.productInfo.phone}`"> {{db.productInfo.phone}} </a>
                </li>
                <li>
                  <i class="fas fa-globe-asia"></i>
                  <a :href="db.productInfo.website">{{db.productInfo.website}}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--Footer Content End-->
    <!--Footer Copyright Start-->
    <section class="tj-copyright">
      <div class="container">
        <div class="row" v-html="db.productInfo.bottomDescription">
          <!-- <div class="col-md-8 col-sm-8">
            <p v-html="db.productInfo.bottomDescription">
               {{db.productInfo.bottomDescription}} -->
              <!-- <br>
              &copy; Copyrights {{currentYear}}
              <a href="home-1.html">{{db.productInfo.name}}</a>. All Rights Reserved. 
            </p>
          </div>
          <div class="col-md-4 col-sm-4">
            <ul class="payment-icons">
              <li>
                <i class="fab fa-cc-visa"></i>
              </li>
              <li>
                <i class="fab fa-cc-mastercard"></i>
              </li>
              <li>
                <i class="fab fa-cc-paypal"></i>
              </li>
              <li>
                <i class="fab fa-cc-discover"></i>
              </li>
              <li>
                <i class="fab fa-cc-jcb"></i>
              </li>
            </ul>
          </div> -->
        </div>
      </div>
    </section>
    <!--Footer Copyright End-->
  </div>
</template>
<script>
import firebase from "firebase";
export default {
  data() {
    return {
      db: null,
      currentYear: new Date().getFullYear()
    };
  },
  created() {
    let that = this;
    var ref = firebase.database().ref();
    ref.on(
      "value",
      function(snapshot) {
        that.db = snapshot.val();
      },
      function(error) {
        console.log("Error: " + error.code);
      }
    );
  },
  methods: {
    movetoTop() {
      document.documentElement.scrollTop = 200;  // For Safari
      document.documentElement.scrollTop = 200;  // For Chrome, Firefox, IE and Opera
    }
  },
  mounted() {
    console.log(this.$route.query.page);
    
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
};
</script>
<style scoped>
.logo-c {
  height: 100px;
  padding-top: 6px;
}
@media (max-width: 767px) {
  .logo-container {
    text-align: center;
  }
}
</style>